import React from 'react';

import {t} from 'l10n';

import {MEMBER_TYPE_FREE, MEMBER_TYPE_XXL, MEMBER_TYPE_TEXT} from '../constants/memberTypes';

class MemberType extends React.Component {

    render() {
        const {memberType} = this.props;

        if (memberType === null) return false;

        let status;
        switch (memberType) {
            case MEMBER_TYPE_XXL: status = MEMBER_TYPE_TEXT[MEMBER_TYPE_XXL]; break;
            case MEMBER_TYPE_FREE: status = MEMBER_TYPE_TEXT[MEMBER_TYPE_FREE]; break;
        }

        return status ? <span className="user-status">({t(status)})</span> : null;

    }
}

export default MemberType;


// WEBPACK FOOTER //
// ./src/components/MemberType.js